import React from 'react';
import { useAdmin } from '../../context/AdminContext';
import AdminLogin from './AdminLogin';
import RecordsPage from '../Records/Records';

/** /admin：未登录显示登录页，已登录显示数据管理 */
export default function AdminPage() {
  const { isAdmin } = useAdmin();
  return isAdmin ? <RecordsPage /> : <AdminLogin />;
}
